/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0761/0266/4472/files/20251021-p1.png",
    "https://cdn.shopify.com/s/files/1/0761/0266/4472/files/20251021-p2.png",
    "https://cdn.shopify.com/s/files/1/0761/0266/4472/files/20251021-p3.png",

    "https://cdn.shopify.com/s/files/1/0761/0266/4472/files/20251021-banner.png",
  ];
  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 1,
    },
    slidesPerView: "auto",
    loop: true,
    speed: 24000,
    spaceBetween: 25,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() +
          $(".sp-header-top").height() +
          $(".sp-nav").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  $(".product-box .sp-opt").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let _index = $(this).index();

    $(this)
      .parents(".product-box")
      .find(".sp-p-img")
      .eq([_index])
      .show()
      .siblings(".sp-p-img")
      .hide();
  });

    $(".sp-btn-style").click(function () {
        let id = $(this).attr('data-id')
        if(!id){
            id = $(".sp-opt-group .active").attr("data-id");
        }
        window.location.href = "/cart/" + id + ":" + 1;
    });
    // $(".buy2").click(function () {
    //     let id1 = $(".sp-pop2 #sp-color1 .active").attr("data-id");
    //     let id2 = $(".sp-pop2 #sp-color2 .active").attr("data-id");
    //     window.location.href = `/cart/${id1}:1,${id2}:1`
    // });
    // $(".buy3").click(function () {
    //     let id1 = $(".sp-pop3 #sp-color1 .active").attr("data-id");
    //     let id2 = $(".sp-pop3 #sp-color2 .active").attr("data-id");
    //     let id3 = $(".sp-pop3 #sp-color3 .active").attr("data-id");
    //     window.location.href = `/cart/${id1}:1,${id2}:1,${id3}:1`
    // });

//   $(".sp-pop2 .sp-option").click(function () {
//     $(this).siblings().removeClass("active");
//     $(this).addClass("active");
//     // style选项

//     let colorOptions = $(".sp-pop2 .sp-color1 .sp-option.active").index();
//     let colorOptions2 = $(".sp-pop2 .sp-color2 .sp-option.active").index();
//     $(".sp-pop2 .spimg1")[0].src = spImgList[colorOptions];
//     $(".sp-pop2 .spimg2")[0].src = spImgList[colorOptions2];
//   });

//   $(".sp-pop3 .sp-option").click(function () {
//     $(this).siblings().removeClass("active");
//     $(this).addClass("active");
//     // style选项

//     let colorOptions = $(".sp-pop3 .sp-color1 .sp-option.active").index();
//     let colorOptions2 = $(".sp-pop3 .sp-color2 .sp-option.active").index();
//     let colorOptions3 = $(".sp-pop3 .sp-color3 .sp-option.active").index();
//     $(".sp-pop3 .spimg1")[0].src = spImgList[colorOptions];
//     $(".sp-pop3 .spimg2")[0].src = spImgList[colorOptions2];
//     $(".sp-pop3 .spimg3")[0].src = spImgList[colorOptions3];
//   });

//   // 展示多选商品
//   $(".product-box2 .sp-btn-style2").click(function () {
//     $(".sp-mask").css("display", "flex");
//     $(".sp-pop2").show();
//     $(".sp-pop3").hide();
//   });
//   $(".product-box2 .sp-btn-style3").click(function () {
//     $(".sp-mask").css("display", "flex");
//     $(".sp-pop3").show();
//     $(".sp-pop2").hide();
//   });

//   // 关闭弹窗按钮

//   $(".sp-pop .sp-close-btn").click(function (e) {
//     $(".sp-mask").hide();
//     $(".sp-pop2").hide();
//     $(".sp-pop3").hide();
//   });
//   $(".sp-pop2 .sp-close-btn").click(function (e) {
//     $(".sp-mask").hide();
//     $(".sp-pop2").hide();
//   });
//   $(".sp-pop3 .sp-close-btn").click(function (e) {
//     $(".sp-mask").hide();
//     $(".sp-pop3").hide();
//   });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }
});
